import { __makeTemplateObject } from '../../../../../../../../node_modules/tslib/tslib.es6.js';
import { styled, Typography } from '@mui/material';
import { ArrowDropUp } from '@mui/icons-material';

var Indicator = styled(ArrowDropUp)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 14px;\n  height: 15.5px;\n  margin: 0 -2px;\n\n  ", "\n"], ["\n  width: 14px;\n  height: 15.5px;\n  margin: 0 -2px;\n\n  ", "\n"])), function (_a) {
    var isPositive = _a.isPositive;
    return "\n    transform: ".concat(isPositive ? "rotateX(0deg)" : "rotateX(180deg)", ";\n  ");
});
var ValueIndicator = styled(Typography, {
    shouldForwardProp: function (p) { return p !== "smallPct"; },
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-flex;\n  font-size: 15px;\n  line-height: 24px;\n  font-weight: 500;\n  align-items: center;\n\n  span::after {\n    content: \"", "\";\n    font-size: 70%;\n    transform: translateY(-13%);\n    display: inline-block;\n  }\n"], ["\n  display: inline-flex;\n  font-size: 15px;\n  line-height: 24px;\n  font-weight: 500;\n  align-items: center;\n\n  span::after {\n    content: \"", "\";\n    font-size: 70%;\n    transform: translateY(-13%);\n    display: inline-block;\n  }\n"])), function (_a) {
    var smallPct = _a.smallPct;
    return (smallPct ? "%" : "");
});
var templateObject_1, templateObject_2;

export { Indicator, ValueIndicator };
